import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
export const usePrimaryCtaChristmas = t0 => {
  const $ = _c(13);
  const {
    sponsorships
  } = t0;
  const {
    t
  } = useTranslation("my");
  const count = sponsorships.length;
  let t1;
  if ($[0] !== t) {
    t1 = t("my:primaryCtaChristmas.title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const title = t1;
  const t2 = sponsorships[0]?.participant?.name ?? "";
  const t3 = sponsorships[1]?.participant?.name ?? "";
  const t4 = count === 2 ? "two" : undefined;
  let t5;
  if ($[2] !== count || $[3] !== t || $[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = t("my:primaryCtaChristmas.subtitle", {
      name: t2,
      name2: t3,
      count,
      context: t4
    });
    $[2] = count;
    $[3] = t;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const subtitle = t5;
  let t6;
  if ($[8] !== count || $[9] !== subtitle || $[10] !== t || $[11] !== title) {
    t6 = {
      t,
      count,
      title,
      subtitle
    };
    $[8] = count;
    $[9] = subtitle;
    $[10] = t;
    $[11] = title;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};